import React from "react"
import CircularProgress from "@mui/material/CircularProgress"

const Loading: React.FC = () => (
  <div
    style={{
      width: "100%",
      textAlign: "center",
    }}
    data-cy="loading-indicator"
  >
    <CircularProgress aria-label="Loading" />
  </div>
)

export default Loading
